import CollectionStore from 'stores/CollectionStore';
import GameInterface from 'app/interfaces/GameInterface';
import {action, makeObservable, observable, override} from 'mobx';
import {FilterStore} from 'app/store/filters/FilterStore';

export const OTHER = 0;

export class GamesStore extends CollectionStore<GameInterface> {
    feedUrl = null;

    channel = null;

    @observable esports = false;

    @observable loaded = false;

    private filterStores: FilterStore[] = [];

    constructor() {
        super();
        makeObservable(this);
    }

    @action
    registerFilterStores(filterStores: FilterStore[]): void {
        this.filterStores.push(...filterStores);
    }

    @override
    init(collection: GameInterface[]): void {
        super.init(collection);

        this.filterStores.forEach(store => store.setGames(collection));
        this.loaded = true;
    }

    @action
    changeEsports(esportStatus: boolean): void {
        this.esports = esportStatus;
    }

    @action
    gameSelect(game_id: number): number {
        return game_id === OTHER ? this.bySportWithoutOther[0].id : game_id;
    }

    @action
    findGameById(game_id: number): GameInterface {
        return this.collection.find(game => game.id === game_id);
    }

    @action
    lastGame(): GameInterface {
        return this.collection[0];
    }

    get esport(): GameInterface[] {
        return this.collection.filter(game => game.esports);
    }

    get bySportWithoutOther(): GameInterface[] {
        return this.collection.filter(game => game.id !== OTHER);
    }
}
